// Constants Imports
import { strings } from "@/lib/data/site/strings";

export type SearchKeyConfig =
  | {
      type: 'keyword';
      facets: Record<string, string[]>;
      filters?: {
        exclude?: string[];
      };
      label: string;
      description?: string;
      meta?: {
        title?: string;
        description?: string;
      };
    }
  | {
      type: 'query';
      query: string | string[];
      facets?: Record<string, string[]>;
      filters?: {
        exclude?: string[];
      };
      label: string;
      description: string;
      meta?: {
        title?: string;
        description?: string;
      };
    };

export const SEARCH_KEY_MAPPING: Record<string, SearchKeyConfig> = {
  'all-products': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'All Products',
    meta: {
      title: `Buy Party Supplies Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'bottle-service': {
    type: 'query',
    query: ["sparkler", "topper", "presenter", "sticker", "tray"],
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Bottle Service',
    meta: {
      title: `Buy Party Supplies Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'bottle-service/sparklers': {
    type: 'query',
    query: ["sparkler", "topper"],
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Sparklers & Toppers',
    meta: {
      title: `Buy Sparklers & Toppers Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'bottle-service/bottle-presenters': {
    type: 'query',
    query: 'presenter',
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Bottle Presenters',
    meta: {
      title: `Buy Bottle Presenters Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'bottle-service/stickers': {
    type: 'query',
    query: 'sticker',
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Stickers',
    meta: {
      title: `Buy Stickers Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'bottle-service/trays': {
    type: 'query',
    query: 'tray',
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Trays',
    meta: {
      title: `Buy Trays Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'party-supplies': {
    type: 'keyword',
    facets: {
      'subcategory.keyword': ['Nightlife Party Supplies'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Party Supplies',
    meta: {
      title: `Buy Party Supplies Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'party-supplies/party-kits': {
    type: 'query',
    query: 'party kit',
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Party Kits',
    meta: {
      title: `Buy Party Kits Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'party-supplies/confetti-poppers': {
    type: 'query',
    query: 'confetti',
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Confetti Poppers',
    meta: {
      title: `Buy Confetti Poppers Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'party-supplies/ice-buckets': {
    type: 'query',
    query: 'bucket',
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Ice Buckets',
    meta: {
      title: `Buy Ice Buckets Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'menus-and-signs': {
    type: 'query',
    query: ['sign', 'menu'],
    facets: {
      'category.keyword': ['Gifts'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Menus & Signs',
    meta: {
      title: `Buy Menus & Signs Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'soda-syrups': {
    type: 'keyword',
    facets: {
      'subcategory.keyword': ['Bib Syrup'],
    },
    description: 'Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.',
    label: 'Soda Syrups',
    meta: {
      title: `Buy Soda Syrups Online | Shop Party Supplies | ${strings.brandNameShort}`,
      description: `Look no further than our selection of party and nightlife supplies for your next event, private bar or venue! We have what you need to create a vibrant atmosphere.`,
    }
  },
  'wine': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
    },
    filters: {
      exclude: ['size.keyword'],
    },
    label: 'Wine',
    meta: {
      title: `Buy Wine Online | Shop Red, White, Sparkling Wines | ${strings.brandNameShort}`,
      description: `You can count on ${strings.brandNameShort} to have the wine you want! We offer an incredible selection of wines at great prices &ndash; shop today!`,
    }
  },
  'wine/red-wine': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Petite Sirah', 'Port', 'Cabernet Sauvignon', 'Merlot', 'Pinot Noir', 'Zinfandel', 'Nebbioloe', 'Montepulciano', 'Chianti', 'Sangiovese', 'Syrah / Shiraz', 'Malbec', 'Barbera', 'Dolcetto', 'Tempranillo', 'Bordeaux Blend', 'Nebbiolo', 'Rioja', 'Rhone Blend', 'Syrah', 'Blend / Table Wine', 'Red Wine'],
    },
    label: 'Red Wine',
    meta: {
      title: `Shop Red Wines | ${strings.brandNameShort}`,
      description: 'Discover our wide selection of red wines, perfect for any occasion or meal pairing.',
    }
  },
  'wine/red-wine/cabernet-sauvignon': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Cabernet Sauvignon'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Cabernet Sauvignon',
    description: 'Discover the bold character of Cabernet Sauvignon, renowned for its deep flavors of dark fruit, firm tannins, and elegant structure. Sourced from top regions like Napa Valley and Bordeaux, our Cabernet Sauvignon collection showcases the best of this classic varietal. Shop our collection to find exceptional bottles that elevate weeknight dinners or make a statement at any celebration.',
    meta: {
      title: `Cabernet Sauvignon Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Cabernet Sauvignon wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/red-wine/pinot-noir': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Pinot Noir'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Pinot Noir',
    description: 'Experience the allure of Pinot Noir, celebrated for its vibrant red fruit flavors, silky texture, and graceful complexity. Sourced from renowned regions like Burgundy, Oregon, and Sonoma, our Pinot Noir collection features expressive bottles for any occasion. Explore our selection to discover the elegance and versatility of this classic varietal.',
    meta: {
      title: `Pinot Noir Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Pinot Noir wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/red-wine/malbec': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Malbec'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Malbec',
    description: 'Explore the rich intensity of Malbec, known for its bold flavors of ripe plum, blackberry, and subtle spice. Sourced from leading regions like Mendoza and Cahors, our Malbec collection highlights the depth and character that define this celebrated varietal. Discover exceptional bottles perfect for pairing with hearty meals or enjoying on their own.',
    meta: {
      title: `Malbec Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Malbec wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/red-wine/merlot': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Merlot'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Merlot',
    description: 'Discover the approachable elegance of Merlot, prized for its lush plum and berry flavors, soft tannins, and smooth finish. Featuring top selections from regions like Bordeaux, California, and Washington State, our Merlot collection showcases the versatility and charm of this beloved varietal. Browse our curated offerings to find bottles ideal for any occasion, from casual dinners to special celebrations.',
    meta: {
      title: `Merlot Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Merlot wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/red-wine/zinfandel': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Zinfandel'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Zinfandel',
    description: 'Experience the bold and expressive character of Zinfandel, celebrated for its jammy berry flavors, peppery spice, and full-bodied richness. Our Zinfandel collection features standout bottles from premier regions like California’s Sonoma and Napa Valley. Explore our selection to find the perfect Zinfandel for barbecue pairings, festive gatherings, or relaxed evenings at home.',
    meta: {
      title: `Zinfandel Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Zinfandel wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/white-wine': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Sauvignon Blanc', 'Chardonnay', 'Moscato', 'Riesling', 'Pinot Grigio', 'White Wine', 'Gewurztraminer', 'Chablis', 'Chenin Blanc', 'Viognier']
    },
    label: 'White Wine',
    meta: {
      title: `Shop White Wines | ${strings.brandNameShort}`,
      description: 'Discover our wide selection of white wines, perfect for any occasion or meal pairing.',
    }
  },
  'wine/white-wine/moscato': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Moscato'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Moscato',
    description: 'Indulge in the vibrant sweetness of Moscato, known for its fragrant floral aromas, juicy stone fruit flavors, and refreshing finish. Our Moscato collection features selections from renowned regions like Piedmont and California, offering a delightful balance of lightness and flavor. Discover the perfect Moscato for brunch, dessert pairings, or effortless sipping any time.',
    meta: {
      title: `Moscato Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Moscato wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/white-wine/chardonnay': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Chardonnay'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Chardonnay',
    description: 'Experience the versatility of Chardonnay, celebrated for its bright citrus, orchard fruit flavors, and subtle notes of oak or creaminess. Our Chardonnay collection features standout bottles from premier regions like Burgundy, California, and Australia. Explore our selection to find the perfect Chardonnay for pairing with seafood, poultry, or simply enjoying on its own.',
    meta: {
      title: `Chardonnay Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Chardonnay wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/white-wine/sauvignon-blanc': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Sauvignon Blanc'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Sauvignon Blanc',
    description: 'Discover the crisp, refreshing appeal of Sauvignon Blanc, prized for its vibrant citrus, tropical fruit flavors, and lively acidity. Our Sauvignon Blanc collection features top selections from renowned regions like Marlborough, Loire Valley, and California. Explore our range to find the ideal Sauvignon Blanc for pairing with seafood, salads, or enjoying as a bright aperitif.',
    meta: {
      title: `Sauvignon Blanc Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Sauvignon Blanc wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/white-wine/pinot-grigio': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Pinot Grigio'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Pinot Grigio',
    description: 'Light, crisp, and refreshingly easy to drink, Pinot Grigio stands out for its subtle citrus and green apple notes with a clean finish. From Italy’s iconic Veneto and Alto Adige regions to the sun-kissed vineyards of California, our Pinot Grigio selection offers versatile wines suited for any occasion. Whether paired with seafood, salads, or enjoyed on its own, these bottles promise effortless enjoyment.',
    meta: {
      title: `Pinot Grigio Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Pinot Grigio wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/white-wine/riesling': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Riesling'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Riesling',
    description: 'Bright acidity and aromatic intensity define Riesling, a varietal loved for its expressive notes of citrus, stone fruit, and sometimes a hint of minerality or floral sweetness. Sourced from storied regions like Germany’s Mosel, Washington State, and Australia’s Clare Valley, our Riesling collection highlights the diversity and elegance of this classic grape. Perfect as an aperitif or paired with spicy cuisine, these wines deliver a memorable experience in every glass.',
    meta: {
      title: `Riesling Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Riesling wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/champagne': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Champagne']
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Champagne',
    description: 'Effervescent and elegant, Champagne offers a harmonious balance of lively bubbles, delicate fruit flavors, and subtle toasty notes. Featuring renowned producers from France’s legendary Champagne region, our curated selection showcases bottles perfect for marking special moments or elevating any gathering. Whether you’re toasting an achievement or enjoying a quiet celebration, these sparkling wines bring sophistication to every occasion.',
    meta: {
      title: `Champagne Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Champagne wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/sparkling-wine': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Sparkling Wine']
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Sparkling Wine',
    description: 'Vibrant and festive, sparkling wine brings a refreshing burst of bubbles and lively fruit flavors to any occasion. Our collection features standout bottles from celebrated regions around the world, including Prosecco from Italy, Cava from Spain, and California sparkling wines. Whether you’re hosting a brunch, marking a milestone, or simply enjoying a spontaneous celebration, these sparkling wines add a touch of joy to every glass.',
    meta: {
      title: `Sparkling Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated sparkling wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/rose-blush-wine': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Rosé / Blush']
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Blush / Rosé Wine',
    description: 'Rosé wines charm with their delicate hues and vibrant flavors of strawberry, citrus, and melon, striking a perfect balance between freshness and subtle complexity. From Provence’s sun-soaked vineyards to California and beyond, our rosé collection highlights expressive bottles suited for warm afternoons, picnics, or relaxed evenings with friends. Raise a glass and enjoy the versatility and charm that make blush and rosé wines perennial favorites.',
    meta: {
      title: `Blush / Rosé Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Blush / Rosé wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/non-alcoholic': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Non-alcoholic']
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Non-Alcoholic Wine',
    description: 'Non-alcoholic wines offer all the character and nuance of traditional wines, with refreshing flavors and aromatic profiles—just without the alcohol. Our thoughtfully curated selection features reds, whites, and sparkling options crafted for inclusive enjoyment, whether you’re seeking a mindful alternative or planning a gathering where everyone feels welcome. Sip and savor the experience of wine, anytime and on any occasion.',
    meta: {
      title: `Non-Alcoholic Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Non-Alcoholic wines available online at ${strings.brandNameShort}.`,
    }
  },
  'wine/sake': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Wine'],
      'category_group.keyword': ['Sake']
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Sake Wine',
    description: 'Sake captivates with its delicate balance of subtle sweetness, umami, and refined floral or fruity notes, making it a uniquely versatile beverage. Our collection features premium sakes from Japan’s most esteemed breweries, ranging from crisp, light styles to rich and complex expressions. Enjoy sake chilled, warmed, or paired with a wide array of cuisines for an authentic and memorable tasting experience.',
    meta: {
      title: `Sake Wine | ${strings.brandNameShort}`,
      description: `Explore top-rated Sake wines available online at ${strings.brandNameShort}.`,
    }
  },
  'spirits': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Spirits'],
    },
    label: 'Spirits',
    meta: {
      title: `Buy Spirits Online | ${strings.brandNameShort}`,
      description: `You can count on ${strings.brandNameShort} to have the spirits you want! We offer an incredible selection of wines at great prices &ndash; shop today!`,
    }
  },
  'spirits/bourbon': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['bourbon', 'boutique bourbon & whiskey'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Bourbon',
    description: 'Bourbon stands out for its rich, layered flavors of caramel, vanilla, and spice, with a smooth finish that embodies true American craftsmanship. Our selection highlights top producers from Kentucky and beyond, offering everything from classic small-batch bottles to limited releases. Whether you’re savoring it neat, on the rocks, or in your favorite cocktail, these bourbons bring warmth and complexity to any occasion.',
    meta: {
      title: `Buy Bourbon Online | ${strings.brandNameShort}`,
      description: `You can count on ${strings.brandNameShort} to have the bourbon you want! We offer an incredible selection of wines at great prices &ndash; shop today!`,
    }
  },
  'spirits/whiskey': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['blended whiskey', 'boutique bourbon & whiskey', 'canadian whiskey', 'other whiskeys', 'rye whiskey', 'whiskey flavored'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Whiskey',
    description: 'Whiskey is celebrated for its depth and complexity, offering a spectrum of flavors from rich caramel and toasted oak to subtle fruit and spice notes. Our curated collection features distinguished bottles from renowned regions like Scotland, Ireland, the United States, and Japan, showcasing the diversity and craftsmanship of this timeless spirit. Enjoy whiskey your way—neat, on the rocks, or as the foundation for a classic cocktail.',
    meta: {
      title: `Buy Whiskey Online | ${strings.brandNameShort}`,
      description: `Discover a premium selection of whiskey from top regions like Scotland, Ireland, the United States, and Japan. Shop single malts, blends, and rare bottles with rich flavors and expert craftsmanship—perfect for collectors, connoisseurs, and every whiskey enthusiast.`,
    }
  },
  'spirits/gin': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['gin'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Gin',
    description: 'Explore our curated selection of gin, featuring premium bottles from leading distilleries around the world. Find classic London dry gins, contemporary botanical blends, and unique small-batch expressions—perfect for cocktails, refreshing gin & tonics, or sipping straight. Shop now for top-rated gins and discover your new favorite.',
    meta: {
      title: `Buy Gin Online | ${strings.brandNameShort}`,
      description: `Explore our curated selection of gin, featuring premium bottles from leading distilleries around the world. Find classic London dry gins, contemporary botanical blends, and unique small-batch expressions—perfect for cocktails, refreshing gin & tonics, or sipping straight. Shop now for top-rated gins and discover your new favorite.`,
    }
  },
  'spirits/rum': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['rum'],
    },
    label: 'Rum',
    description: 'Shop our diverse collection of rum, featuring top-rated bottles from the Caribbean, Latin America, and beyond. Discover everything from classic white and dark rums to spiced and aged varieties, perfect for sipping neat, mixing in cocktails, or elevating your favorite recipes. Find your next favorite rum and enjoy rich, complex flavors in every glass.',
    meta: {
      title: `Buy Rum Online | ${strings.brandNameShort}`,
      description: `Shop our diverse collection of rum, featuring top-rated bottles from the Caribbean, Latin America, and beyond. Discover everything from classic white and dark rums to spiced and aged varieties, perfect for sipping neat, mixing in cocktails, or elevating your favorite recipes. Find your next favorite rum and enjoy rich, complex flavors in every glass.`,
    }
  },
  'spirits/scotch': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['scotch blends', 'scotch malts'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Scotch',
    description: 'Browse our premium selection of Scotch whisky, including single malts and blended Scotch from Scotland’s renowned distilleries. Discover bottles with rich, smoky, and complex flavors—perfect for collectors, connoisseurs, or anyone seeking to enjoy the tradition and craftsmanship of true Scotch. Shop top brands and rare finds for your next memorable dram.',
    meta: {
      title: `Buy Scotch Online | ${strings.brandNameShort}`,
      description: `Browse our premium selection of Scotch whisky, including single malts and blended Scotch from Scotland’s renowned distilleries. Discover bottles with rich, smoky, and complex flavors—perfect for collectors, connoisseurs, or anyone seeking to enjoy the tradition and craftsmanship of true Scotch. Shop top brands and rare finds for your next memorable dram.`,
    }
  },
  'spirits/tequila': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['tequila','tequila super premium','flavored tequila'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Tequila',
    description: 'Discover a top selection of tequila, featuring premium bottles from Mexico’s finest distilleries. Explore blanco, reposado, and añejo tequilas with vibrant agave flavors and smooth finishes—perfect for sipping neat, mixing in cocktails, or celebrating any occasion. Shop now to find your new favorite tequila and elevate your next gathering.',
    meta: {
      title: `Buy Tequila Online | ${strings.brandNameShort}`,
      description: `Discover a top selection of tequila, featuring premium bottles from Mexico’s finest distilleries. Explore blanco, reposado, and añejo tequilas with vibrant agave flavors and smooth finishes—perfect for sipping neat, mixing in cocktails, or celebrating any occasion. Shop now to find your new favorite tequila and elevate your next gathering.`,
    }
  },
  'spirits/vodka': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['us vodka', 'flavored vodka', 'imported vodka', 'texas vodka'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Vodka',
    description: 'Shop our extensive vodka collection, featuring top brands and artisanal distilleries from around the world. Find ultra-smooth vodkas ideal for classic cocktails, creative mixes, or sipping chilled. Discover your next favorite vodka and elevate every occasion with clean, crisp flavor and versatility.',
    meta: {
      title: `Buy Vodka Online | ${strings.brandNameShort}`,
      description: `Shop our extensive vodka collection, featuring top brands and artisanal distilleries from around the world. Find ultra-smooth vodkas ideal for classic cocktails, creative mixes, or sipping chilled. Discover your next favorite vodka and elevate every occasion with clean, crisp flavor and versatility.`,
    }
  },
  'cocktails': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['cocktails', 'cocktails canned or small size'],
    },
    label: 'Cocktails',
    description: '',
    meta: {
      title: `Buy Cocktails Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'cocktails/liqueurs': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['cream liqueurs'],
    },
    label: 'Liqueurs',
    description: 'Explore our selection of liqueurs, featuring a variety of flavors and styles perfect for cocktails or sipping. From creamy indulgences to herbal and fruity options, our curated collection offers something for every palate. Discover unique liqueurs that elevate your drinks and add a touch of creativity to your mixology.',
    meta: {
      title: `Buy Liqueurs Online | ${strings.brandNameShort}`,
      description: `Explore our selection of liqueurs, featuring a variety of flavors and styles perfect for cocktails or sipping. From creamy indulgences to herbal and fruity options, our curated collection offers something for every palate. Discover unique liqueurs that elevate your drinks and add a touch of creativity to your mixology.`,
    }
  },
  'cocktails/ingredients-mixers': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['mixers'],
    },
    label: 'Mixers',
    description: 'Explore our wide range of mixers, including tonic water, ginger beer, club soda, juices, and more—perfect for crafting cocktails or enjoying on their own. Find premium and classic mixers from top brands to complement any spirit and elevate your home bar. Shop now for the essential mixers to create your favorite drinks.',
    meta: {
      title: `Buy Liqueurs Online | ${strings.brandNameShort}`,
      description: `Explore our wide range of mixers, including tonic water, ginger beer, club soda, juices, and more—perfect for crafting cocktails or enjoying on their own. Find premium and classic mixers from top brands to complement any spirit and elevate your home bar. Shop now for the essential mixers to create your favorite drinks.`,
    }
  },
  'cocktails/ready-to-drink': {
    type: 'keyword',
    facets: {
      'category_group.keyword': ['ready to drink'],
    },
    label: 'Mixers',
    description: 'Shop our selection of ready-to-drink cocktails and beverages, featuring top brands and a variety of flavors. Enjoy the convenience of expertly mixed drinks—just chill, open, and serve. Perfect for parties, picnics, or relaxing at home, these RTD options bring bar-quality cocktails to any occasion.',
    meta: {
      title: `Buy Liqueurs Online | ${strings.brandNameShort}`,
      description: `Shop our selection of ready-to-drink cocktails and beverages, featuring top brands and a variety of flavors. Enjoy the convenience of expertly mixed drinks—just chill, open, and serve. Perfect for parties, picnics, or relaxing at home, these RTD options bring bar-quality cocktails to any occasion.`,
    }
  },
  'spirits/non-alcoholic': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['alcohol free spirits'],
    },
    label: 'Non-Alcoholic',
    description: 'Discover our curated range of non-alcoholic spirits, offering all the complexity and flavor of traditional spirits without the alcohol. Perfect for mindful drinking, mocktails, and inclusive gatherings, these alcohol-free options let you enjoy classic cocktails and creative drinks anytime. Shop now for top non-alcoholic gin, whiskey, rum, and more.',
    meta: {
      title: `Buy Non-Alcoholic Spirits Online | ${strings.brandNameShort}`,
      description: `Discover our curated range of non-alcoholic spirits, offering all the complexity and flavor of traditional spirits without the alcohol. Perfect for mindful drinking, mocktails, and inclusive gatherings, these alcohol-free options let you enjoy classic cocktails and creative drinks anytime. Shop now for top non-alcoholic gin, whiskey, rum, and more.`,
    }
  },
  'beer': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Beer'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Beer',
    description: 'Explore our diverse beer selection, featuring craft brews, imports, and domestic favorites from leading breweries. Find lagers, ales, IPAs, stouts, and more to suit any taste or occasion. Shop now to discover new releases and classic beers perfect for gatherings, game days, or unwinding at home.',
    meta: {
      title: `Buy Beer Online | ${strings.brandNameShort}`,
      description: `Explore our diverse beer selection, featuring craft brews, imports, and domestic favorites from leading breweries. Find lagers, ales, IPAs, stouts, and more to suit any taste or occasion. Shop now to discover new releases and classic beers perfect for gatherings, game days, or unwinding at home.`,
    }
  },
  'beer/ipa': {
    type: 'query',
    query: 'ipa',
    facets: {
      'category.keyword': ['Beer'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'IPA',
    description: 'Explore our selection of IPAs (India Pale Ales) from leading craft breweries, featuring bold hop flavors, citrus and pine aromas, and a variety of styles from hazy to West Coast. Shop top India Pale Ale releases and classics—perfect for beer lovers seeking big flavor and refreshment.',
    meta: {
      title: `Buy IPA Beer Online | ${strings.brandNameShort}`,
      description: `Explore our selection of IPAs (India Pale Ales) from leading craft breweries, featuring bold hop flavors, citrus and pine aromas, and a variety of styles from hazy to West Coast. Shop top India Pale Ale releases and classics—perfect for beer lovers seeking big flavor and refreshment.`,
    }
  },
  'beer/lager': {
    type: 'query',
    query: '',
    facets: {
      'category.keyword': ['Beer'],
      'category_group.keyword': ['Lager', 'Pilsner', 'Bock'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Lager',
    description: 'Discover our curated collection of lager beers, featuring crisp, refreshing flavors from top breweries around the world. Shop classic pale lagers, amber lagers, and unique craft varieties—perfect for any occasion. Find your new favorite lager to enjoy with meals, at gatherings, or when you want a clean, easy-drinking beer.',
    meta: {
      title: `Buy Lager Beer Online | ${strings.brandNameShort}`,
      description: `Discover our curated collection of lager beers, featuring crisp, refreshing flavors from top breweries around the world. Shop classic pale lagers, amber lagers, and unique craft varieties—perfect for any occasion. Find your new favorite lager to enjoy with meals, at gatherings, or when you want a clean, easy-drinking beer.`,
    }
  },
  'beer/pale-ale': {
    type: 'query',
    query: 'pale ale',
    facets: {
      'category.keyword': ['Beer'],
      'category_group.keyword': ['Pale Ale'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Pale Ale',
    description: 'Browse our selection of pale ales, featuring balanced malt and hop flavors with bright, refreshing character. Discover top pale ale beers from renowned craft breweries and classic producers, perfect for any occasion. Shop now to find your new favorite pale ale for pairing with meals or enjoying with friends.',
    meta: {
      title: `Buy Pale Ale Beer Online | ${strings.brandNameShort}`,
      description: `Browse our selection of pale ales, featuring balanced malt and hop flavors with bright, refreshing character. Discover top pale ale beers from renowned craft breweries and classic producers, perfect for any occasion. Shop now to find your new favorite pale ale for pairing with meals or enjoying with friends.`,
    }
  },
  'beer/stout': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Beer'],
      'category_group.keyword': ['Stout'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Stout',
    description: 'Explore our stout beer collection, featuring rich, bold flavors with notes of roasted malt, chocolate, and coffee. Shop classic stouts, imperial stouts, and craft varieties from top breweries around the world. Find the perfect stout for savoring on a cozy night in or sharing with fellow beer enthusiasts.',
    meta: {
      title: `Buy Stout Beer Online | ${strings.brandNameShort}`,
      description: `Explore our stout beer collection, featuring rich, bold flavors with notes of roasted malt, chocolate, and coffee. Shop classic stouts, imperial stouts, and craft varieties from top breweries around the world. Find the perfect stout for savoring on a cozy night in or sharing with fellow beer enthusiasts.`,
    }
  },
  'beer/hard-seltzer': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Beer'],
      'category_group.keyword': ['Hard Seltzer'],
    },
    filters: {
      exclude: ['category_group.keyword'],
    },
    label: 'Hard Seltzer',
    description: 'Explore our collection of hard seltzers, featuring a wide range of fruity flavors and sparkling refreshment. Shop top hard seltzer brands and discover light, low-calorie beverages perfect for parties, picnics, or casual sipping. Find your new favorite hard seltzer for a crisp, easy-drinking alternative to beer and cocktails.',
    meta: {
      title: `Buy Hard Seltzer Online | ${strings.brandNameShort}`,
      description: `Explore our collection of hard seltzers, featuring a wide range of fruity flavors and sparkling refreshment. Shop top hard seltzer brands and discover light, low-calorie beverages perfect for parties, picnics, or casual sipping. Find your new favorite hard seltzer for a crisp, easy-drinking alternative to beer and cocktails.`,
    }
  },
  'cider': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Beer'],
      'category_group.keyword': ['Cider'],
    },
    label: 'Cider',
    description: 'Discover our selection of ciders, featuring crisp, refreshing flavors made from apples, pears, and other fruits. Shop a variety of traditional and craft ciders from top producers, perfect for any occasion. Find your favorite cider to enjoy on its own or paired with meals for a naturally delicious alternative to beer and wine.',
    meta: {
      title: `Buy Cider Online | ${strings.brandNameShort}`,
      description: `Discover our selection of ciders, featuring crisp, refreshing flavors made from apples, pears, and other fruits. Shop a variety of traditional and craft ciders from top producers, perfect for any occasion. Find your favorite cider to enjoy on its own or paired with meals for a naturally delicious alternative to beer and wine.`,
    }
  },
  'beer/non-alcoholic': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Beer'],
      'category_group.keyword': ['Non-alcoholic'],
    },
    label: 'Non-Alcoholic',
    description: 'Shop our wide range of non-alcoholic beers, offering classic beer taste without the alcohol. Explore lagers, ales, IPAs, and more from top brands and craft breweries. Enjoy the full flavor and refreshment of beer—perfect for any occasion where you want a mindful, alcohol-free option.',
    meta: {
      title: `Buy Non-Alcoholic Beer Online | ${strings.brandNameShort}`,
      description: `Shop our wide range of non-alcoholic beers, offering classic beer taste without the alcohol. Explore lagers, ales, IPAs, and more from top brands and craft breweries. Enjoy the full flavor and refreshment of beer—perfect for any occasion where you want a mindful, alcohol-free option.`,
    }
  },
  'beer/infused-seltzers': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Infused Seltzers'],
    },
    label: 'Infused Seltzers',
    meta: {
      title: `Buy Infused Seltzers Online | Shop Red, White, Sparkling Wines | ${strings.brandNameShort}`,
      description: `Discover our selection of infused seltzers, featuring sparkling beverages enhanced with real fruit flavors, botanicals, and creative infusions. Shop top brands and unique options for a refreshing twist on classic seltzer—perfect for parties, picnics, or relaxing anytime. Find your new favorite infused seltzer for a flavorful, easy-drinking experience.`,
    }
  },
  'foods': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Foods'],
    },
    label: 'Food',
    meta: {
      title: `Buy Food Online | Shop Red, White, Sparkling Wines | ${strings.brandNameShort}`,
      description: `You can count on ${strings.brandNameShort} to have the food you want! We offer an incredible selection of food at great prices &ndash; shop today!`,
    }
  },
  'foods/cheese': {
    type: 'query',
    query: 'cheese',
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Cheese']
    },
    label: 'Cheese',
    description: 'Explore our curated cheese collection, featuring artisanal and classic varieties from around the world. Shop everything from creamy brie and tangy blue cheese to aged cheddars and fresh mozzarella—perfect for pairing with wine, entertaining guests, or elevating everyday meals. Find your new favorite cheese and experience rich, delicious flavors in every bite.',
    meta: {
      title: `Buy Cheese Online | ${strings.brandNameShort}`,
      description: `Explore our curated cheese collection, featuring artisanal and classic varieties from around the world. Shop everything from creamy brie and tangy blue cheese to aged cheddars and fresh mozzarella—perfect for pairing with wine, entertaining guests, or elevating everyday meals. Find your new favorite cheese and experience rich, delicious flavors in every bite.`,
    }
  },
  'foods/chips': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Chips', 'Nuts, Snacks']
    },
    label: 'Chips & Snacks',
    description: 'Shop our wide selection of chips and snacks, including gourmet potato chips, crunchy pretzels, popcorn, and unique specialty treats. Discover top brands and new favorites—perfect for parties, game nights, or everyday snacking. Find the best snacks to satisfy every craving and add flavor to any occasion.',
    meta: {
      title: `Buy Chips & Snacks Online | ${strings.brandNameShort}`,
      description: `Shop our wide selection of chips and snacks, including gourmet potato chips, crunchy pretzels, popcorn, and unique specialty treats. Discover top brands and new favorites—perfect for parties, game nights, or everyday snacking. Find the best snacks to satisfy every craving and add flavor to any occasion.`,
    }
  },
  'foods/meats': {
    type: 'query',
    query: 'meat',
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Miscellaneous', 'Finer Foods', 'Cheese', 'Seafood', 'Holiday Foods']
    },
    label: 'Meat',
    description:'',
    meta: {
      title: `Buy Meat Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'foods/nuts': {
    type: 'query',
    query: 'nuts',
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Nuts, Snacks', 'Chips', 'Sweets', 'Holiday Foods', 'Finer Foods', 'Spices']
    },
    label: 'Nuts',
    description:'',
    meta: {
      title: `Buy Nuts Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'foods/sweets': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Sweets']
    },
    label: 'Sweets',
    description:'',
    meta: {
      title: `Buy Sweets Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'foods/jams-jellies-syrups': {
    type: 'query',
    query: ["jam", "jelly", "syrup"],
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Sweets', 'Nuts, Snacks', 'Cheese', 'Holiday Foods']
    },
    label: 'Jams, Jellies & Syrups',
    description:'',
    meta: {
      title: `Buy Jams, Jellies & Syrups Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'foods/salsas-spreads-sauces': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Salsas, Spreads, Sauces']
    },
    label: 'Salsas, Spreads & Sauces',
    description:'',
    meta: {
      title: `Buy Salsas, Spreads & Sauces Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'foods/sauces-condiments-chutneys': {
    type: 'query',
    query: ['sauce', 'condiment', 'chutney'],
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Salsas, Spreads, Sauces', 'Finer Foods', 'Miscellaneous', 'Holiday Foods']
    },
    label: 'Sauces, Condiments & Chutneys',
    description:'',
    meta: {
      title: `Buy Sauces, Condiments & Chutneys Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'foods/soft-drinks': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Sodas']
    },
    label: 'Soft Drinks',
    description:'',
    meta: {
      title: `Buy Soft Drinks Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'foods/water': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Foods'],
      'subcategory.keyword': ['Water']
    },
    label: 'Water',
    description:'',
    meta: {
      title: `Buy Water Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'more/glassware': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Glassware']
    },
    label: 'Glassware',
    description:'',
    meta: {
      title: `Buy Glassware Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'more/bar-accessories': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Bar Accessories']
    },
    label: 'Bar Accessories',
    description:'',
    meta: {
      title: `Buy Bar Accessories Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'more/nightlife-party-supplies': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['party supplies', 'nightlife party supplies'],
    },
    label: 'Party Supplies',
    description:'',
    meta: {
      title: `Buy Party Supplies Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'gifts': {
    type: 'keyword',
    facets: {
      'category.keyword': ['Gifts']
    },
    label: 'Gifts',
    description:'',
    meta: {
      title: `Buy Gifts Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'gifts/specs-swag': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['specs gear apparel'],
    },
    label: 'Specs Gear & Apparel',
    description:'',
    meta: {
      title: `Buy Specs Gear & Apparel Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
  'gifts/gift-cards': {
    type: 'keyword',
    facets: {
      'main_taxonomy.keyword': ['gift cards'],
    },
    label: 'Gift Cards',
    description:'',
    meta: {
      title: `Buy Gift Cards Online | ${strings.brandNameShort}`,
      description: ``,
    }
  },
};
